import React, { useState, useEffect } from "react";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { useParams, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";

import baseURL from "../../Url/Url.jsx";
import SideBar from "../../Layout/SideBar.jsx";

const MenuLaporanSpt = () => {
    //DATE & NAVIGATION
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const year = today.getFullYear();

    const navigate = useNavigate();

    const { perusahaanParams, bulanParams, tahunParams } = useParams();

    // STATE
    const [npwpPerusahaan, setNpwpPerusahaan] = useState("");
    const [npwpPenandatangan, setNpwpPenandatangan] = useState("");
    const [perusahaan, setPerusahaan] = useState("");
    const [bulan, setBulan] = useState("");
    const [tahun, setTahun] = useState("");
    const [expire, setExpire] = useState("");

    const [search, setSearch] = useState("");
    const [selectedXML, setSelectedXML] = useState("");
    const [xmlPreview, setXmlPreview] = useState("");

    const [perhitunganTetap, setPerhitunganTetap] = useState([]);
    const [perhitunganTidakTetap, setPerhitunganTidakTetap] = useState([]);

    // EFFECT
    useEffect(() => {
        refreshToken();
    }, []);
    useEffect(() => {
        if (perusahaan) {
            fetchPerusahaan();
        }
    }, [perusahaan]);
    useEffect(() => {
        fetchPerhitungan();
    }, [search]);
    useEffect(() => {
        setSelectedXML("BPMP");
        setXmlPreview(generateMmPayrollXML());
    }, [perhitunganTetap, perhitunganTidakTetap]);    

    // AUTH
    const refreshToken = async () => {
        try {
            const res = await axios.get(`${baseURL}/tokenBE`);
            const decoded = jwt_decode(res.data.accessToken);
            setPerusahaan(decoded.perusahaan);
            setBulan(decoded.bulan);
            setTahun(decoded.tahun);
            setExpire(decoded.exp);
        } catch {
            navigate("/", { replace: true });
        }
    };

    // API DATA
    const fetchPerusahaan = async () => {
        try {
            if (!perusahaan) return;
            const res = await axios.get(`${baseURL}/selectPerusahaanBE/${perusahaanParams}`);
            if (res.data.length > 0) {
                const npwpRaw = res.data[0].npwpPerusahaan;
                const npwpAngka = npwpRaw.replace(/\D/g, "");
                setNpwpPerusahaan(npwpAngka);
                const npwpRaw2 = res.data[0].npwpPenandatangananSpt;
                const npwpAngka2 = npwpRaw2.replace(/\D/g, "");
                setNpwpPenandatangan(npwpAngka2);
            }
        } catch (err) {
            console.error("Fetch perusahaan error:", err);
        }
    };    

    // API DATA
    const fetchPerhitungan = async () => {
        const query = search ? `?search=${encodeURIComponent(search)}` : "";
        try {
            const [tetap, tidakTetap] = await Promise.all([
                axios.get(`${baseURL}/selectPerhitunganTetapBE/${perusahaanParams}/${bulanParams}/${tahunParams}${query}`),
                axios.get(`${baseURL}/selectPerhitunganTidakTetapBE/${perusahaanParams}/${bulanParams}/${tahunParams}${query}`)
            ]);
            setPerhitunganTetap(tetap.data);
            setPerhitunganTidakTetap(tidakTetap.data);
        } catch (err) {
            console.error("Fetch error:", err.message);
        }
    };

    // LOGOUT
    const Logout = async () => {
        await axios.delete(`${baseURL}/logoutBE`);
        navigate("/", { replace: true });
    };

    const normalizeStatusKawin = (status) => {
        if (!status) return "TK/0";
      
        let s = String(status).toUpperCase().replace(/\s/g, "");
      
        // ubah T/K jadi TK
        if (s === "T/K") s = "TK";
      
        // jika format K0 atau TK1
        if (/^(TK|K)[0-3]$/.test(s)) {
          return s.replace(/(TK|K)([0-3])/, "$1/$2");
        }
      
        // jika sudah benar
        if (/^(TK|K)\/[0-3]$/.test(s)) {
          return s;
        }
      
        // jika hanya TK
        if (s === "TK") return "TK/0";
      
        return "TK/0";
      };

    const handleSelectXML = (e) => {
        const value = e.target.value;
        setSelectedXML(value);
        if (value === "BPMP") {
            setXmlPreview(generateMmPayrollXML());
        } else if (value === "BP21") {
            setXmlPreview(generateBp21XML());
        } else if (value === "BPA1") {
            setXmlPreview(generateA1XML());
        } else {
            setXmlPreview("");
        }
    };    

    const handleExportXML = () => {
        if (!selectedXML) return;
    
        if (selectedXML === "BPMP") {
            if (!npwpPenandatangan || !npwpPerusahaan) {
                alert("Isi TIN dan ID TKU Pada DB Perusahaan");
                return;
            }
            downloadXML(generateMmPayrollXML(), `BPMP_${perusahaanParams}_${bulan}_${tahun}.xml`);
        }

        // if (selectedXML === "BP21") {
        //     downloadXML(generateBp21XML(), `BP21_${perusahaanParams}_${bulan}_${tahun}.xml`);
        // }
    
        if (selectedXML === "BPA1") {
            downloadXML(generateA1XML(), `BPA1_${perusahaanParams}_${tahun}.xml`);
        }
    };    

    const handleExportExcel = () => {
        if (!selectedXML) return;
    
        if (selectedXML === "BPMP") {
            if (!npwpPenandatangan || !npwpPerusahaan) {
                alert("Isi TIN dan ID TKU Pada DB Perusahaan");
                return;
            }
            exportMmPayrollExcel(perhitunganTetap);
        }
    
        // if (selectedXML === "BP21") {
        //     exportBP21Excel(perhitunganTetap);
        // }
    
        // if (selectedXML === "BPA1") {
        //     exportA1Excel(perhitunganTetap);
        // }
    };

    const exportMmPayrollExcel = (data) => {
        const formatted = data.map((u) => {
            const gajiBruto = Number(u.gajiBruto) || 0;
            const statusKawin = (u.statusKawin || "").toUpperCase();
            let tarif = 0;
            if (
                ["TK", "T/K", "TK/0", "TK0", "TK/1", "TK1", "K/0", "K0"]
                    .includes(statusKawin)
            ) {
                if (gajiBruto <= 5400000) tarif = 0.00;
                else if (gajiBruto <= 5650000) tarif = 0.25;
                else if (gajiBruto <= 5950000) tarif = 0.50;
                else if (gajiBruto <= 6300000) tarif = 0.75;
                else if (gajiBruto <= 6750000) tarif = 1.00;
                else if (gajiBruto <= 7500000) tarif = 1.25;
                else if (gajiBruto <= 8550000) tarif = 1.50;
                else if (gajiBruto <= 9650000) tarif = 1.75;
                else if (gajiBruto <= 10050000) tarif = 2.00;
                else if (gajiBruto <= 10350000) tarif = 2.25;
                else if (gajiBruto <= 10700000) tarif = 2.50;
                else if (gajiBruto <= 11050000) tarif = 3.00;
                else if (gajiBruto <= 11600000) tarif = 3.50;
                else if (gajiBruto <= 12500000) tarif = 4.00;
                else if (gajiBruto <= 13750000) tarif = 5.00;
                else if (gajiBruto <= 15100000) tarif = 6.00;
                else if (gajiBruto <= 16950000) tarif = 7.00;
                else if (gajiBruto <= 19750000) tarif = 8.00;
                else if (gajiBruto <= 24150000) tarif = 9.00;
                else if (gajiBruto <= 26450000) tarif = 10.00;
                else if (gajiBruto <= 28000000) tarif = 11.00;
                else if (gajiBruto <= 30050000) tarif = 12.00;
                else if (gajiBruto <= 32400000) tarif = 13.00;
                else if (gajiBruto <= 35400000) tarif = 14.00;
                else if (gajiBruto <= 39100000) tarif = 15.00;
                else if (gajiBruto <= 43850000) tarif = 16.00;
                else if (gajiBruto <= 47800000) tarif = 17.00;
                else if (gajiBruto <= 51400000) tarif = 18.00;
                else if (gajiBruto <= 56300000) tarif = 19.00;
                else if (gajiBruto <= 62200000) tarif = 20.00;
                else if (gajiBruto <= 68600000) tarif = 21.00;
                else if (gajiBruto <= 77500000) tarif = 22.00;
                else if (gajiBruto <= 89000000) tarif = 23.00;
                else if (gajiBruto <= 103000000) tarif = 24.00;
                else if (gajiBruto <= 125000000) tarif = 25.00;
                else if (gajiBruto <= 157000000) tarif = 26.00;
                else if (gajiBruto <= 206000000) tarif = 27.00;
                else if (gajiBruto <= 337000000) tarif = 28.00;
                else if (gajiBruto <= 454000000) tarif = 29.00;
                else if (gajiBruto <= 550000000) tarif = 30.00;
                else if (gajiBruto <= 695000000) tarif = 31.00;
                else if (gajiBruto <= 910000000) tarif = 32.00;
                else if (gajiBruto <= 1400000000) tarif = 33.00;
                else tarif = 34.00;
            }else if (
                ["TK/2", "TK2", "K/1", "K1", "TK/3", "TK3", "K/2", "K2"]
                    .includes(statusKawin)
            ) {
            
                if (gajiBruto <= 6200000) tarif = 0;
                else if (gajiBruto <= 6500000) tarif = 0.25;
                else if (gajiBruto <= 6850000) tarif = 0.50;
                else if (gajiBruto <= 7300000) tarif = 0.75;
                else if (gajiBruto <= 9200000) tarif = 1.00;
                else if (gajiBruto <= 10750000) tarif = 1.50;
                else if (gajiBruto <= 11250000) tarif = 2.00;
                else if (gajiBruto <= 11600000) tarif = 2.50;
                else if (gajiBruto <= 12600000) tarif = 3.00;
                else if (gajiBruto <= 13600000) tarif = 4.00;
                else if (gajiBruto <= 14950000) tarif = 5.00;
                else if (gajiBruto <= 16400000) tarif = 6.00;
                else if (gajiBruto <= 18450000) tarif = 7.00;
                else if (gajiBruto <= 21850000) tarif = 8.00;
                else if (gajiBruto <= 26000000) tarif = 9.00;
                else if (gajiBruto <= 27700000) tarif = 10.00;
                else if (gajiBruto <= 29350000) tarif = 11.00;
                else if (gajiBruto <= 31450000) tarif = 12.00;
                else if (gajiBruto <= 33950000) tarif = 13.00;
                else if (gajiBruto <= 37100000) tarif = 14.00;
                else if (gajiBruto <= 41100000) tarif = 15.00;
                else if (gajiBruto <= 45800000) tarif = 16.00;
                else if (gajiBruto <= 49500000) tarif = 17.00;
                else if (gajiBruto <= 53800000) tarif = 18.00;
                else if (gajiBruto <= 58500000) tarif = 19.00;
                else if (gajiBruto <= 64000000) tarif = 20.00;
                else if (gajiBruto <= 71000000) tarif = 21.00;
                else if (gajiBruto <= 80000000) tarif = 22.00;
                else if (gajiBruto <= 93000000) tarif = 23.00;
                else if (gajiBruto <= 109000000) tarif = 24.00;
                else if (gajiBruto <= 129000000) tarif = 25.00;
                else if (gajiBruto <= 163000000) tarif = 26.00;
                else if (gajiBruto <= 211000000) tarif = 27.00;
                else if (gajiBruto <= 374000000) tarif = 28.00;
                else if (gajiBruto <= 459000000) tarif = 29.00;
                else if (gajiBruto <= 555000000) tarif = 30.00;
                else if (gajiBruto <= 704000000) tarif = 31.00;
                else if (gajiBruto <= 957000000) tarif = 32.00;
                else if (gajiBruto <= 1405000000) tarif = 33.00;
                else tarif = 34.00;
            }else if (["K/3", "K3"].includes(statusKawin)) {
                if (gajiBruto <= 6600000) tarif = 0;
                else if (gajiBruto <= 6950000) tarif = 0.25;
                else if (gajiBruto <= 7350000) tarif = 0.50;
                else if (gajiBruto <= 7800000) tarif = 0.75;
                else if (gajiBruto <= 8850000) tarif = 1.00;
                else if (gajiBruto <= 9800000) tarif = 1.25;
                else if (gajiBruto <= 10950000) tarif = 1.50;
                else if (gajiBruto <= 11200000) tarif = 1.75;
                else if (gajiBruto <= 12050000) tarif = 2.00;
                else if (gajiBruto <= 12950000) tarif = 3.00;
                else if (gajiBruto <= 14150000) tarif = 4.00;
                else if (gajiBruto <= 15550000) tarif = 5.00;
                else if (gajiBruto <= 17050000) tarif = 6.00;
                else if (gajiBruto <= 19500000) tarif = 7.00;
                else if (gajiBruto <= 22700000) tarif = 8.00;
                else if (gajiBruto <= 26600000) tarif = 9.00;
                else if (gajiBruto <= 28100000) tarif = 10.00;
                else if (gajiBruto <= 30100000) tarif = 11.00;
                else if (gajiBruto <= 32600000) tarif = 12.00;
                else if (gajiBruto <= 35400000) tarif = 13.00;
                else if (gajiBruto <= 38900000) tarif = 14.00;
                else if (gajiBruto <= 43000000) tarif = 15.00;
                else if (gajiBruto <= 47400000) tarif = 16.00;
                else if (gajiBruto <= 51200000) tarif = 17.00;
                else if (gajiBruto <= 55800000) tarif = 18.00;
                else if (gajiBruto <= 60400000) tarif = 19.00;
                else if (gajiBruto <= 66700000) tarif = 20.00;
                else if (gajiBruto <= 74500000) tarif = 21.00;
                else if (gajiBruto <= 83200000) tarif = 22.00;
                else if (gajiBruto <= 95600000) tarif = 23.00;
                else if (gajiBruto <= 110000000) tarif = 24.00;
                else if (gajiBruto <= 134000000) tarif = 25.00;
                else if (gajiBruto <= 169000000) tarif = 26.00;
                else if (gajiBruto <= 221000000) tarif = 27.00;
                else if (gajiBruto <= 390000000) tarif = 28.00;
                else if (gajiBruto <= 463000000) tarif = 29.00;
                else if (gajiBruto <= 561000000) tarif = 30.00;
                else if (gajiBruto <= 709000000) tarif = 31.00;
                else if (gajiBruto <= 965000000) tarif = 32.00;
                else if (gajiBruto <= 1419000000) tarif = 33.00;
                else tarif = 34.00;
            }
            return {
                MasaPajak: getBulanAngka(bulan),
                TahunPajak: tahun,
                StatusPegawai: "Resident",
                KTP: (u.ktp || "").replace(/\D/g, ""),
                NomorPassport: "",
                Status: normalizeStatusKawin(u.statusKawin),
                Posisi: (u.jabatan || "-").replace(/&/g, ""),
                Sertifikat: "N/A",
                KodeObjekPajak: "21-100-01",
                Bruto: u.gajiBruto,
                Tarif: tarif,
                IDTKU: npwpPerusahaan,
                TglPemotongan: `${year}-${month}-${day}`
            };
        });
        const worksheet = XLSX.utils.json_to_sheet(formatted);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Payroll");
        XLSX.writeFile(
            workbook,
            `Laporan_Coretax_${perusahaanParams}_${bulan}_${tahun}.xlsx`
        );
    };

    // Convert bulan
    const bulanMap = {
        januari: 1,
        februari: 2,
        maret: 3,
        april: 4,
        mei: 5,
        juni: 6,
        juli: 7,
        agustus: 8,
        september: 9,
        oktober: 10,
        november: 11,
        desember: 12,
    };
    const getBulanAngka = (bulan) => {
        if (!bulan) return "";
        return bulanMap[bulan.toLowerCase()] || "";
    };
    
    // XML BP21 GENERATOR
    const generateBp21Tetap = (data) =>
        data.map((u) => {
            const gajiBruto = Number(u.gajiBruto) || 0;
            const statusKawin = (u.statusKawin || "").toUpperCase();
            let tarif = 0;
            if (
                ["TK", "T/K", "TK/0", "TK0", "TK/1", "TK1", "K/0", "K0"]
                    .includes(statusKawin)
            ) {
                if (gajiBruto <= 5400000) tarif = 0.00;
                else if (gajiBruto <= 5650000) tarif = 0.25;
                else if (gajiBruto <= 5950000) tarif = 0.50;
                else if (gajiBruto <= 6300000) tarif = 0.75;
                else if (gajiBruto <= 6750000) tarif = 1.00;
                else if (gajiBruto <= 7500000) tarif = 1.25;
                else if (gajiBruto <= 8550000) tarif = 1.50;
                else if (gajiBruto <= 9650000) tarif = 1.75;
                else if (gajiBruto <= 10050000) tarif = 2.00;
                else if (gajiBruto <= 10350000) tarif = 2.25;
                else if (gajiBruto <= 10700000) tarif = 2.50;
                else if (gajiBruto <= 11050000) tarif = 3.00;
                else if (gajiBruto <= 11600000) tarif = 3.50;
                else if (gajiBruto <= 12500000) tarif = 4.00;
                else if (gajiBruto <= 13750000) tarif = 5.00;
                else if (gajiBruto <= 15100000) tarif = 6.00;
                else if (gajiBruto <= 16950000) tarif = 7.00;
                else if (gajiBruto <= 19750000) tarif = 8.00;
                else if (gajiBruto <= 24150000) tarif = 9.00;
                else if (gajiBruto <= 26450000) tarif = 10.00;
                else if (gajiBruto <= 28000000) tarif = 11.00;
                else if (gajiBruto <= 30050000) tarif = 12.00;
                else if (gajiBruto <= 32400000) tarif = 13.00;
                else if (gajiBruto <= 35400000) tarif = 14.00;
                else if (gajiBruto <= 39100000) tarif = 15.00;
                else if (gajiBruto <= 43850000) tarif = 16.00;
                else if (gajiBruto <= 47800000) tarif = 17.00;
                else if (gajiBruto <= 51400000) tarif = 18.00;
                else if (gajiBruto <= 56300000) tarif = 19.00;
                else if (gajiBruto <= 62200000) tarif = 20.00;
                else if (gajiBruto <= 68600000) tarif = 21.00;
                else if (gajiBruto <= 77500000) tarif = 22.00;
                else if (gajiBruto <= 89000000) tarif = 23.00;
                else if (gajiBruto <= 103000000) tarif = 24.00;
                else if (gajiBruto <= 125000000) tarif = 25.00;
                else if (gajiBruto <= 157000000) tarif = 26.00;
                else if (gajiBruto <= 206000000) tarif = 27.00;
                else if (gajiBruto <= 337000000) tarif = 28.00;
                else if (gajiBruto <= 454000000) tarif = 29.00;
                else if (gajiBruto <= 550000000) tarif = 30.00;
                else if (gajiBruto <= 695000000) tarif = 31.00;
                else if (gajiBruto <= 910000000) tarif = 32.00;
                else if (gajiBruto <= 1400000000) tarif = 33.00;
                else tarif = 34.00;
            }else if (
                ["TK/2", "TK2", "K/1", "K1", "TK/3", "TK3", "K/2", "K2"]
                    .includes(statusKawin)
            ) {
            
                if (gajiBruto <= 6200000) tarif = 0;
                else if (gajiBruto <= 6500000) tarif = 0.25;
                else if (gajiBruto <= 6850000) tarif = 0.50;
                else if (gajiBruto <= 7300000) tarif = 0.75;
                else if (gajiBruto <= 9200000) tarif = 1.00;
                else if (gajiBruto <= 10750000) tarif = 1.50;
                else if (gajiBruto <= 11250000) tarif = 2.00;
                else if (gajiBruto <= 11600000) tarif = 2.50;
                else if (gajiBruto <= 12600000) tarif = 3.00;
                else if (gajiBruto <= 13600000) tarif = 4.00;
                else if (gajiBruto <= 14950000) tarif = 5.00;
                else if (gajiBruto <= 16400000) tarif = 6.00;
                else if (gajiBruto <= 18450000) tarif = 7.00;
                else if (gajiBruto <= 21850000) tarif = 8.00;
                else if (gajiBruto <= 26000000) tarif = 9.00;
                else if (gajiBruto <= 27700000) tarif = 10.00;
                else if (gajiBruto <= 29350000) tarif = 11.00;
                else if (gajiBruto <= 31450000) tarif = 12.00;
                else if (gajiBruto <= 33950000) tarif = 13.00;
                else if (gajiBruto <= 37100000) tarif = 14.00;
                else if (gajiBruto <= 41100000) tarif = 15.00;
                else if (gajiBruto <= 45800000) tarif = 16.00;
                else if (gajiBruto <= 49500000) tarif = 17.00;
                else if (gajiBruto <= 53800000) tarif = 18.00;
                else if (gajiBruto <= 58500000) tarif = 19.00;
                else if (gajiBruto <= 64000000) tarif = 20.00;
                else if (gajiBruto <= 71000000) tarif = 21.00;
                else if (gajiBruto <= 80000000) tarif = 22.00;
                else if (gajiBruto <= 93000000) tarif = 23.00;
                else if (gajiBruto <= 109000000) tarif = 24.00;
                else if (gajiBruto <= 129000000) tarif = 25.00;
                else if (gajiBruto <= 163000000) tarif = 26.00;
                else if (gajiBruto <= 211000000) tarif = 27.00;
                else if (gajiBruto <= 374000000) tarif = 28.00;
                else if (gajiBruto <= 459000000) tarif = 29.00;
                else if (gajiBruto <= 555000000) tarif = 30.00;
                else if (gajiBruto <= 704000000) tarif = 31.00;
                else if (gajiBruto <= 957000000) tarif = 32.00;
                else if (gajiBruto <= 1405000000) tarif = 33.00;
                else tarif = 34.00;
            }else if (["K/3", "K3"].includes(statusKawin)) {
                if (gajiBruto <= 6600000) tarif = 0;
                else if (gajiBruto <= 6950000) tarif = 0.25;
                else if (gajiBruto <= 7350000) tarif = 0.50;
                else if (gajiBruto <= 7800000) tarif = 0.75;
                else if (gajiBruto <= 8850000) tarif = 1.00;
                else if (gajiBruto <= 9800000) tarif = 1.25;
                else if (gajiBruto <= 10950000) tarif = 1.50;
                else if (gajiBruto <= 11200000) tarif = 1.75;
                else if (gajiBruto <= 12050000) tarif = 2.00;
                else if (gajiBruto <= 12950000) tarif = 3.00;
                else if (gajiBruto <= 14150000) tarif = 4.00;
                else if (gajiBruto <= 15550000) tarif = 5.00;
                else if (gajiBruto <= 17050000) tarif = 6.00;
                else if (gajiBruto <= 19500000) tarif = 7.00;
                else if (gajiBruto <= 22700000) tarif = 8.00;
                else if (gajiBruto <= 26600000) tarif = 9.00;
                else if (gajiBruto <= 28100000) tarif = 10.00;
                else if (gajiBruto <= 30100000) tarif = 11.00;
                else if (gajiBruto <= 32600000) tarif = 12.00;
                else if (gajiBruto <= 35400000) tarif = 13.00;
                else if (gajiBruto <= 38900000) tarif = 14.00;
                else if (gajiBruto <= 43000000) tarif = 15.00;
                else if (gajiBruto <= 47400000) tarif = 16.00;
                else if (gajiBruto <= 51200000) tarif = 17.00;
                else if (gajiBruto <= 55800000) tarif = 18.00;
                else if (gajiBruto <= 60400000) tarif = 19.00;
                else if (gajiBruto <= 66700000) tarif = 20.00;
                else if (gajiBruto <= 74500000) tarif = 21.00;
                else if (gajiBruto <= 83200000) tarif = 22.00;
                else if (gajiBruto <= 95600000) tarif = 23.00;
                else if (gajiBruto <= 110000000) tarif = 24.00;
                else if (gajiBruto <= 134000000) tarif = 25.00;
                else if (gajiBruto <= 169000000) tarif = 26.00;
                else if (gajiBruto <= 221000000) tarif = 27.00;
                else if (gajiBruto <= 390000000) tarif = 28.00;
                else if (gajiBruto <= 463000000) tarif = 29.00;
                else if (gajiBruto <= 561000000) tarif = 30.00;
                else if (gajiBruto <= 709000000) tarif = 31.00;
                else if (gajiBruto <= 965000000) tarif = 32.00;
                else if (gajiBruto <= 1419000000) tarif = 33.00;
                else tarif = 34.00;
            }
            return `
            <Bp21>
                <TaxPeriodMonth>${getBulanAngka(bulan)}</TaxPeriodMonth>
                <TaxPeriodYear>${tahun}</TaxPeriodYear>
                <CounterpartTin>${u.ktp.replace(/\D/g, "")}</CounterpartTin>
                <IDPlaceOfBusinessActivityOfIncomeRecipient>${npwpPerusahaan}</IDPlaceOfBusinessActivityOfIncomeRecipient>
                <StatusTaxExemption>${normalizeStatusKawin(u.statusKawin)}</StatusTaxExemption>
                <TaxCertificate>N/A</TaxCertificate>
                <TaxObjectCode>21-100-01</TaxObjectCode>
                <Gross>${u.gajiBruto}</Gross>
                <Deemed>${getBulanAngka(bulan) === 12 ? 50 : 100}</Deemed>
                <Rate>${tarif}</Rate>
                <Document></Document>
                <DocumentNumber></DocumentNumber>
                <DocumentDate></DocumentDate>
                <IDPlaceOfBusinessActivity>${npwpPerusahaan}</IDPlaceOfBusinessActivity>
                <WithholdingDate>${year}-${month}-${day}</WithholdingDate>
            </Bp21>
        `}).join("");
    const generateBp21TidakTetap = (data) =>
        data.map((u) => {
            const gajiBruto = Number(u.gajiBruto) || 0;
            const statusKawin = (u.statusKawin || "").toUpperCase();
            let tarif = 0;
            if (
                ["TK", "T/K", "TK/0", "TK0", "TK/1", "TK1", "K/0", "K0"]
                    .includes(statusKawin)
            ) {
                if (gajiBruto <= 5400000) tarif = 0.00;
                else if (gajiBruto <= 5650000) tarif = 0.25;
                else if (gajiBruto <= 5950000) tarif = 0.50;
                else if (gajiBruto <= 6300000) tarif = 0.75;
                else if (gajiBruto <= 6750000) tarif = 1.00;
                else if (gajiBruto <= 7500000) tarif = 1.25;
                else if (gajiBruto <= 8550000) tarif = 1.50;
                else if (gajiBruto <= 9650000) tarif = 1.75;
                else if (gajiBruto <= 10050000) tarif = 2.00;
                else if (gajiBruto <= 10350000) tarif = 2.25;
                else if (gajiBruto <= 10700000) tarif = 2.50;
                else if (gajiBruto <= 11050000) tarif = 3.00;
                else if (gajiBruto <= 11600000) tarif = 3.50;
                else if (gajiBruto <= 12500000) tarif = 4.00;
                else if (gajiBruto <= 13750000) tarif = 5.00;
                else if (gajiBruto <= 15100000) tarif = 6.00;
                else if (gajiBruto <= 16950000) tarif = 7.00;
                else if (gajiBruto <= 19750000) tarif = 8.00;
                else if (gajiBruto <= 24150000) tarif = 9.00;
                else if (gajiBruto <= 26450000) tarif = 10.00;
                else if (gajiBruto <= 28000000) tarif = 11.00;
                else if (gajiBruto <= 30050000) tarif = 12.00;
                else if (gajiBruto <= 32400000) tarif = 13.00;
                else if (gajiBruto <= 35400000) tarif = 14.00;
                else if (gajiBruto <= 39100000) tarif = 15.00;
                else if (gajiBruto <= 43850000) tarif = 16.00;
                else if (gajiBruto <= 47800000) tarif = 17.00;
                else if (gajiBruto <= 51400000) tarif = 18.00;
                else if (gajiBruto <= 56300000) tarif = 19.00;
                else if (gajiBruto <= 62200000) tarif = 20.00;
                else if (gajiBruto <= 68600000) tarif = 21.00;
                else if (gajiBruto <= 77500000) tarif = 22.00;
                else if (gajiBruto <= 89000000) tarif = 23.00;
                else if (gajiBruto <= 103000000) tarif = 24.00;
                else if (gajiBruto <= 125000000) tarif = 25.00;
                else if (gajiBruto <= 157000000) tarif = 26.00;
                else if (gajiBruto <= 206000000) tarif = 27.00;
                else if (gajiBruto <= 337000000) tarif = 28.00;
                else if (gajiBruto <= 454000000) tarif = 29.00;
                else if (gajiBruto <= 550000000) tarif = 30.00;
                else if (gajiBruto <= 695000000) tarif = 31.00;
                else if (gajiBruto <= 910000000) tarif = 32.00;
                else if (gajiBruto <= 1400000000) tarif = 33.00;
                else tarif = 34.00;
            }else if (
                ["TK/2", "TK2", "K/1", "K1", "TK/3", "TK3", "K/2", "K2"]
                    .includes(statusKawin)
            ) {
            
                if (gajiBruto <= 6200000) tarif = 0;
                else if (gajiBruto <= 6500000) tarif = 0.25;
                else if (gajiBruto <= 6850000) tarif = 0.50;
                else if (gajiBruto <= 7300000) tarif = 0.75;
                else if (gajiBruto <= 9200000) tarif = 1.00;
                else if (gajiBruto <= 10750000) tarif = 1.50;
                else if (gajiBruto <= 11250000) tarif = 2.00;
                else if (gajiBruto <= 11600000) tarif = 2.50;
                else if (gajiBruto <= 12600000) tarif = 3.00;
                else if (gajiBruto <= 13600000) tarif = 4.00;
                else if (gajiBruto <= 14950000) tarif = 5.00;
                else if (gajiBruto <= 16400000) tarif = 6.00;
                else if (gajiBruto <= 18450000) tarif = 7.00;
                else if (gajiBruto <= 21850000) tarif = 8.00;
                else if (gajiBruto <= 26000000) tarif = 9.00;
                else if (gajiBruto <= 27700000) tarif = 10.00;
                else if (gajiBruto <= 29350000) tarif = 11.00;
                else if (gajiBruto <= 31450000) tarif = 12.00;
                else if (gajiBruto <= 33950000) tarif = 13.00;
                else if (gajiBruto <= 37100000) tarif = 14.00;
                else if (gajiBruto <= 41100000) tarif = 15.00;
                else if (gajiBruto <= 45800000) tarif = 16.00;
                else if (gajiBruto <= 49500000) tarif = 17.00;
                else if (gajiBruto <= 53800000) tarif = 18.00;
                else if (gajiBruto <= 58500000) tarif = 19.00;
                else if (gajiBruto <= 64000000) tarif = 20.00;
                else if (gajiBruto <= 71000000) tarif = 21.00;
                else if (gajiBruto <= 80000000) tarif = 22.00;
                else if (gajiBruto <= 93000000) tarif = 23.00;
                else if (gajiBruto <= 109000000) tarif = 24.00;
                else if (gajiBruto <= 129000000) tarif = 25.00;
                else if (gajiBruto <= 163000000) tarif = 26.00;
                else if (gajiBruto <= 211000000) tarif = 27.00;
                else if (gajiBruto <= 374000000) tarif = 28.00;
                else if (gajiBruto <= 459000000) tarif = 29.00;
                else if (gajiBruto <= 555000000) tarif = 30.00;
                else if (gajiBruto <= 704000000) tarif = 31.00;
                else if (gajiBruto <= 957000000) tarif = 32.00;
                else if (gajiBruto <= 1405000000) tarif = 33.00;
                else tarif = 34.00;
            }else if (["K/3", "K3"].includes(statusKawin)) {
                if (gajiBruto <= 6600000) tarif = 0;
                else if (gajiBruto <= 6950000) tarif = 0.25;
                else if (gajiBruto <= 7350000) tarif = 0.50;
                else if (gajiBruto <= 7800000) tarif = 0.75;
                else if (gajiBruto <= 8850000) tarif = 1.00;
                else if (gajiBruto <= 9800000) tarif = 1.25;
                else if (gajiBruto <= 10950000) tarif = 1.50;
                else if (gajiBruto <= 11200000) tarif = 1.75;
                else if (gajiBruto <= 12050000) tarif = 2.00;
                else if (gajiBruto <= 12950000) tarif = 3.00;
                else if (gajiBruto <= 14150000) tarif = 4.00;
                else if (gajiBruto <= 15550000) tarif = 5.00;
                else if (gajiBruto <= 17050000) tarif = 6.00;
                else if (gajiBruto <= 19500000) tarif = 7.00;
                else if (gajiBruto <= 22700000) tarif = 8.00;
                else if (gajiBruto <= 26600000) tarif = 9.00;
                else if (gajiBruto <= 28100000) tarif = 10.00;
                else if (gajiBruto <= 30100000) tarif = 11.00;
                else if (gajiBruto <= 32600000) tarif = 12.00;
                else if (gajiBruto <= 35400000) tarif = 13.00;
                else if (gajiBruto <= 38900000) tarif = 14.00;
                else if (gajiBruto <= 43000000) tarif = 15.00;
                else if (gajiBruto <= 47400000) tarif = 16.00;
                else if (gajiBruto <= 51200000) tarif = 17.00;
                else if (gajiBruto <= 55800000) tarif = 18.00;
                else if (gajiBruto <= 60400000) tarif = 19.00;
                else if (gajiBruto <= 66700000) tarif = 20.00;
                else if (gajiBruto <= 74500000) tarif = 21.00;
                else if (gajiBruto <= 83200000) tarif = 22.00;
                else if (gajiBruto <= 95600000) tarif = 23.00;
                else if (gajiBruto <= 110000000) tarif = 24.00;
                else if (gajiBruto <= 134000000) tarif = 25.00;
                else if (gajiBruto <= 169000000) tarif = 26.00;
                else if (gajiBruto <= 221000000) tarif = 27.00;
                else if (gajiBruto <= 390000000) tarif = 28.00;
                else if (gajiBruto <= 463000000) tarif = 29.00;
                else if (gajiBruto <= 561000000) tarif = 30.00;
                else if (gajiBruto <= 709000000) tarif = 31.00;
                else if (gajiBruto <= 965000000) tarif = 32.00;
                else if (gajiBruto <= 1419000000) tarif = 33.00;
                else tarif = 34.00;
            }
            return `
            <Bp21>
                <TaxPeriodMonth>${getBulanAngka(bulan)}</TaxPeriodMonth>
                <TaxPeriodYear>${tahun}</TaxPeriodYear>
                <CounterpartTin>${u.ktp.replace(/\D/g, "")}</CounterpartTin>
                <IDPlaceOfBusinessActivityOfIncomeRecipient>${npwpPerusahaan}</IDPlaceOfBusinessActivityOfIncomeRecipient>
                <StatusTaxExemption>${normalizeStatusKawin(u.statusKawin)}</StatusTaxExemption>
                <TaxCertificate>N/A</TaxCertificate>
                <TaxObjectCode>21-100-35</TaxObjectCode>
                <Gross>${u.gajiBruto}</Gross>
                <Deemed>100</Deemed>
                <Rate>${tarif}</Rate>
                <Document></Document>
                <DocumentNumber></DocumentNumber>
                <DocumentDate></DocumentDate>
                <IDPlaceOfBusinessActivity>${npwpPerusahaan}</IDPlaceOfBusinessActivity>
                <WithholdingDate>${year}-${month}-${day}</WithholdingDate>
            </Bp21>
        `}).join("");
    const generateBp21XML = () => `
        <?xml version="1.0" encoding="UTF-8"?>
        <Bp21Bulk xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
            <TIN>${npwpPenandatangan}</TIN>
            <ListOfBp21>
                ${generateBp21Tetap(perhitunganTetap)}
                ${generateBp21TidakTetap(perhitunganTidakTetap)}
            </ListOfBp21>
        </Bp21Bulk>
        `.trim();

    // MM PAYROLL (BPMP) XML
    const generateMmPayroll = (data) => 
        data.map((u) => {
        const gajiBruto = Number(u.gajiBruto) || 0;
        const statusKawin = (u.statusKawin || "").toUpperCase();
        let tarif = 0;
        if (
            ["TK", "T/K", "TK/0", "TK0", "TK/1", "TK1", "K/0", "K0"]
                .includes(statusKawin)
        ) {
            if (gajiBruto <= 5400000) tarif = 0.00;
            else if (gajiBruto <= 5650000) tarif = 0.25;
            else if (gajiBruto <= 5950000) tarif = 0.50;
            else if (gajiBruto <= 6300000) tarif = 0.75;
            else if (gajiBruto <= 6750000) tarif = 1.00;
            else if (gajiBruto <= 7500000) tarif = 1.25;
            else if (gajiBruto <= 8550000) tarif = 1.50;
            else if (gajiBruto <= 9650000) tarif = 1.75;
            else if (gajiBruto <= 10050000) tarif = 2.00;
            else if (gajiBruto <= 10350000) tarif = 2.25;
            else if (gajiBruto <= 10700000) tarif = 2.50;
            else if (gajiBruto <= 11050000) tarif = 3.00;
            else if (gajiBruto <= 11600000) tarif = 3.50;
            else if (gajiBruto <= 12500000) tarif = 4.00;
            else if (gajiBruto <= 13750000) tarif = 5.00;
            else if (gajiBruto <= 15100000) tarif = 6.00;
            else if (gajiBruto <= 16950000) tarif = 7.00;
            else if (gajiBruto <= 19750000) tarif = 8.00;
            else if (gajiBruto <= 24150000) tarif = 9.00;
            else if (gajiBruto <= 26450000) tarif = 10.00;
            else if (gajiBruto <= 28000000) tarif = 11.00;
            else if (gajiBruto <= 30050000) tarif = 12.00;
            else if (gajiBruto <= 32400000) tarif = 13.00;
            else if (gajiBruto <= 35400000) tarif = 14.00;
            else if (gajiBruto <= 39100000) tarif = 15.00;
            else if (gajiBruto <= 43850000) tarif = 16.00;
            else if (gajiBruto <= 47800000) tarif = 17.00;
            else if (gajiBruto <= 51400000) tarif = 18.00;
            else if (gajiBruto <= 56300000) tarif = 19.00;
            else if (gajiBruto <= 62200000) tarif = 20.00;
            else if (gajiBruto <= 68600000) tarif = 21.00;
            else if (gajiBruto <= 77500000) tarif = 22.00;
            else if (gajiBruto <= 89000000) tarif = 23.00;
            else if (gajiBruto <= 103000000) tarif = 24.00;
            else if (gajiBruto <= 125000000) tarif = 25.00;
            else if (gajiBruto <= 157000000) tarif = 26.00;
            else if (gajiBruto <= 206000000) tarif = 27.00;
            else if (gajiBruto <= 337000000) tarif = 28.00;
            else if (gajiBruto <= 454000000) tarif = 29.00;
            else if (gajiBruto <= 550000000) tarif = 30.00;
            else if (gajiBruto <= 695000000) tarif = 31.00;
            else if (gajiBruto <= 910000000) tarif = 32.00;
            else if (gajiBruto <= 1400000000) tarif = 33.00;
            else tarif = 34.00;
        }else if (
            ["TK/2", "TK2", "K/1", "K1", "TK/3", "TK3", "K/2", "K2"]
                .includes(statusKawin)
        ) {
        
            if (gajiBruto <= 6200000) tarif = 0;
            else if (gajiBruto <= 6500000) tarif = 0.25;
            else if (gajiBruto <= 6850000) tarif = 0.50;
            else if (gajiBruto <= 7300000) tarif = 0.75;
            else if (gajiBruto <= 9200000) tarif = 1.00;
            else if (gajiBruto <= 10750000) tarif = 1.50;
            else if (gajiBruto <= 11250000) tarif = 2.00;
            else if (gajiBruto <= 11600000) tarif = 2.50;
            else if (gajiBruto <= 12600000) tarif = 3.00;
            else if (gajiBruto <= 13600000) tarif = 4.00;
            else if (gajiBruto <= 14950000) tarif = 5.00;
            else if (gajiBruto <= 16400000) tarif = 6.00;
            else if (gajiBruto <= 18450000) tarif = 7.00;
            else if (gajiBruto <= 21850000) tarif = 8.00;
            else if (gajiBruto <= 26000000) tarif = 9.00;
            else if (gajiBruto <= 27700000) tarif = 10.00;
            else if (gajiBruto <= 29350000) tarif = 11.00;
            else if (gajiBruto <= 31450000) tarif = 12.00;
            else if (gajiBruto <= 33950000) tarif = 13.00;
            else if (gajiBruto <= 37100000) tarif = 14.00;
            else if (gajiBruto <= 41100000) tarif = 15.00;
            else if (gajiBruto <= 45800000) tarif = 16.00;
            else if (gajiBruto <= 49500000) tarif = 17.00;
            else if (gajiBruto <= 53800000) tarif = 18.00;
            else if (gajiBruto <= 58500000) tarif = 19.00;
            else if (gajiBruto <= 64000000) tarif = 20.00;
            else if (gajiBruto <= 71000000) tarif = 21.00;
            else if (gajiBruto <= 80000000) tarif = 22.00;
            else if (gajiBruto <= 93000000) tarif = 23.00;
            else if (gajiBruto <= 109000000) tarif = 24.00;
            else if (gajiBruto <= 129000000) tarif = 25.00;
            else if (gajiBruto <= 163000000) tarif = 26.00;
            else if (gajiBruto <= 211000000) tarif = 27.00;
            else if (gajiBruto <= 374000000) tarif = 28.00;
            else if (gajiBruto <= 459000000) tarif = 29.00;
            else if (gajiBruto <= 555000000) tarif = 30.00;
            else if (gajiBruto <= 704000000) tarif = 31.00;
            else if (gajiBruto <= 957000000) tarif = 32.00;
            else if (gajiBruto <= 1405000000) tarif = 33.00;
            else tarif = 34.00;
        }else if (["K/3", "K3"].includes(statusKawin)) {
            if (gajiBruto <= 6600000) tarif = 0;
            else if (gajiBruto <= 6950000) tarif = 0.25;
            else if (gajiBruto <= 7350000) tarif = 0.50;
            else if (gajiBruto <= 7800000) tarif = 0.75;
            else if (gajiBruto <= 8850000) tarif = 1.00;
            else if (gajiBruto <= 9800000) tarif = 1.25;
            else if (gajiBruto <= 10950000) tarif = 1.50;
            else if (gajiBruto <= 11200000) tarif = 1.75;
            else if (gajiBruto <= 12050000) tarif = 2.00;
            else if (gajiBruto <= 12950000) tarif = 3.00;
            else if (gajiBruto <= 14150000) tarif = 4.00;
            else if (gajiBruto <= 15550000) tarif = 5.00;
            else if (gajiBruto <= 17050000) tarif = 6.00;
            else if (gajiBruto <= 19500000) tarif = 7.00;
            else if (gajiBruto <= 22700000) tarif = 8.00;
            else if (gajiBruto <= 26600000) tarif = 9.00;
            else if (gajiBruto <= 28100000) tarif = 10.00;
            else if (gajiBruto <= 30100000) tarif = 11.00;
            else if (gajiBruto <= 32600000) tarif = 12.00;
            else if (gajiBruto <= 35400000) tarif = 13.00;
            else if (gajiBruto <= 38900000) tarif = 14.00;
            else if (gajiBruto <= 43000000) tarif = 15.00;
            else if (gajiBruto <= 47400000) tarif = 16.00;
            else if (gajiBruto <= 51200000) tarif = 17.00;
            else if (gajiBruto <= 55800000) tarif = 18.00;
            else if (gajiBruto <= 60400000) tarif = 19.00;
            else if (gajiBruto <= 66700000) tarif = 20.00;
            else if (gajiBruto <= 74500000) tarif = 21.00;
            else if (gajiBruto <= 83200000) tarif = 22.00;
            else if (gajiBruto <= 95600000) tarif = 23.00;
            else if (gajiBruto <= 110000000) tarif = 24.00;
            else if (gajiBruto <= 134000000) tarif = 25.00;
            else if (gajiBruto <= 169000000) tarif = 26.00;
            else if (gajiBruto <= 221000000) tarif = 27.00;
            else if (gajiBruto <= 390000000) tarif = 28.00;
            else if (gajiBruto <= 463000000) tarif = 29.00;
            else if (gajiBruto <= 561000000) tarif = 30.00;
            else if (gajiBruto <= 709000000) tarif = 31.00;
            else if (gajiBruto <= 965000000) tarif = 32.00;
            else if (gajiBruto <= 1419000000) tarif = 33.00;
            else tarif = 34.00;
        }
        return `
            <MmPayroll>
                <TaxPeriodMonth>${getBulanAngka(bulan)}</TaxPeriodMonth>
                <TaxPeriodYear>${tahun}</TaxPeriodYear>
                <CounterpartOpt>Resident</CounterpartOpt>
                <CounterpartPassport xsi:nil="true"/>
                <CounterpartTin>${u.ktp.replace(/\D/g, "")}</CounterpartTin>
                <StatusTaxExemption>${normalizeStatusKawin(u.statusKawin)}</StatusTaxExemption>
                <Position>${(u.jabatan || "-").replace(/&/g, "")}</Position>
                <TaxCertificate>N/A</TaxCertificate>
                <TaxObjectCode>21-100-01</TaxObjectCode>
                <Gross>${u.gajiBruto}</Gross>
                <Rate>${tarif}</Rate>
                <IDPlaceOfBusinessActivity>${npwpPerusahaan}</IDPlaceOfBusinessActivity>
                <WithholdingDate>${year}-${month}-${day}</WithholdingDate>
            </MmPayroll>
        `}).join("");
    const generateMmPayrollXML = () => `
        <?xml version="1.0" encoding="UTF-8"?>
        <MmPayrollBulk xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
            <TIN>${npwpPenandatangan}</TIN>
            <ListOfMmPayroll>
                ${generateMmPayroll(perhitunganTetap)}
            </ListOfMmPayroll>
        </MmPayrollBulk>
        `.trim();

    // BPA1 (A1) XML
    const generateA1 = (data) =>
        data.map((u) => `
            <A1>
                <WorkForSecondEmployer>No</WorkForSecondEmployer>
                <TaxPeriodMonthStart>${ u.tanggalMasuk && u.tanggalMasuk.split('-')[0] == tahun ? parseInt(u.tanggalMasuk.split('-')[1]) : 1 }</TaxPeriodMonthStart>
                <TaxPeriodMonthEnd>${ u.tanggalKeluar && u.tanggalKeluar.split('-')[0] == tahun ? parseInt(u.tanggalKeluar.split('-')[1]) : 12 }</TaxPeriodMonthEnd>
                <TaxPeriodYear>${tahun}</TaxPeriodYear>
                <CounterpartOpt>Resident</CounterpartOpt>
                <CounterpartPassport xsi:nil="true"/>
                <CounterpartTin>${u.npwp.replace(/\D/g, "")}</CounterpartTin>
                <TaxExemptOpt>${normalizeStatusKawin(u.statusKawin)}</TaxExemptOpt>
                <StatusOfWithholding>FullYear</StatusOfWithholding>
                <CounterpartPosition>${u.jabatan || "-"}</CounterpartPosition>
                <TaxObjectCode>21-100-01</TaxObjectCode>
                <NumberOfMonths>0</NumberOfMonths>
                <SalaryPensionJhtTht>${u.gajiBrutoSetahun || 0}</SalaryPensionJhtTht>
                <GrossUpOpt>No</GrossUpOpt>
                <IncomeTaxBenefit>${u.tPph || 0}</IncomeTaxBenefit>
                <OtherBenefit>${u.lainnya || 0}</OtherBenefit>
                <Honorarium>${0}</Honorarium>
                <InsurancePaidByEmployer>${u.tBKesehatan+u.tBJmk+u.tBJkk+u.tBJht+u.tBPensiun || 0}</InsurancePaidByEmployer>
                <Natura>${u.tPremiHRV+u.tPremiNonHRV+u.tPremiJabatan+u.tPremiBorongan+u.tPremiKontan+u.tPremiLainnya+u.tCatuBeras || 0}</Natura>
                <TantiemBonusThr>${u.thr+u.bonus || 0}</TantiemBonusThr>
                <PensionContributionJhtThtFee>${u.iBKesehatan+u.iBPensiun+u.iBJht+u.pBkesehatan+u.pBPensiun+u.pBJkm+u.pBJkk+u.pBJht || 0}</PensionContributionJhtThtFee>
                <Zakat>${0}</Zakat>
                <PrevWhTaxSlip xsi:nil="true"/>
                <TaxCertificate>N/A</TaxCertificate>
                <Article21IncomeTax>${u.pphBulanIni || 0}</Article21IncomeTax>
                <IDPlaceOfBusinessActivity>${npwpPerusahaan}</IDPlaceOfBusinessActivity>
                <WithholdingDate>${year}-${month}-${day}</WithholdingDate>
            </A1>
        `).join("");
    const generateA1XML = () => `
        <?xml version="1.0" encoding="UTF-8"?>
        <A1Bulk xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
            <TIN>${npwpPenandatangan}</TIN>
            <ListOfA1>
                ${generateA1(perhitunganTetap)}
            </ListOfA1>
        </A1Bulk>
        `.trim();

    // Download XML
    const downloadXML = (xml, filename) => {
        const blob = new Blob([xml], { type: "application/xml" });
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        a.click();
        URL.revokeObjectURL(a.href);
    };
    // Halaman
    return (
        <div id="wrapper">
            {/* SIDE BAR */}
            <SideBar 
                bulanParams={bulan}
                tahunParams={tahun}
                perusahaanParams={perusahaan}
                tahunSekarang={tahun}
            />
            {/* KONTEN WRAP */}
            <div id="content-wrapper">
                {/* NAVBAR */}
                <nav className="navbar navbar-expand-sm sticky-top nav-bar py-3">
                    <div className="container">
                        <div className="dropdown ml-2">
                            <button className="navbar-toggler mb-2" data-bs-toggle="collapse" data-bs-target="#sidebar" aria-controls="sidebar" aria-expanded="false" aria-label="Toggle navigation" style={{border:"none"}}>
                                <i className="bi bi-grid-fill" style={{fontSize:"22px"}}></i>
                            </button>
                        </div>
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0"></ul>
                        <div className="d-flex" role="search">
                           <input type="text" className="form-control form mx-2" placeholder="Cari Nama, NIK, KTP, dll" value={search} onChange={(e) => setSearch(e.target.value)}style={{marginTop:"-2px",color:"rgb(108, 108, 108)",maxWidth:"300px",fontSize:"10pt"}}/>
                            <input type="text" className="form-control form" value={perusahaan} style={{marginTop:"-2px",color:"rgb(108, 108, 108)",fontWeight:"700",maxWidth:"300px"}} readOnly/>
                            <input type="text" className="form-control form mx-2" value={bulan} style={{marginTop:"-2px",color:"rgb(108, 108, 108)",fontWeight:"700",maxWidth:"120px",textAlign:"center"}} readOnly/>
                            <input type="text" className="form-control form" value={tahun} style={{marginTop:"-2px",color:"rgb(108, 108, 108)",fontWeight:"700",maxWidth:"70px",textAlign:"center"}} readOnly/>
                            <button onClick={Logout} className="btn btn-logout mx-2"><i className="bi bi-power" style={{color:"white",fontSize:"22px"}}></i></button>
                        </div>
                    </div>
                </nav>
                {/* KONTEN */}
                <div className="container-fluid" style={{overflow:"auto",display:"block",width:"100%",height:"88vh"}}>
                    <h4 className="text-center my-3" style={{fontWeight:"700"}}>Menu Laporan CoreTax</h4>
                    <div className="row">
                        <div className="col-12">
                            <div className="box p-4 pb-2">
                                <div className="row justify-content-center">
                                    <div className={`${selectedXML=== "BP21"?"col-2":"col-1"} mb-3`}>
                                        <button className="btn xml-btn mx-auto d-block" disabled={!selectedXML}onClick={handleExportXML}><img src={ selectedXML === "BP21"? "/img/xml-bp21.png": selectedXML === "BPMP"? "/img/xml-bpmp.png": selectedXML === "BPA1"? "/img/xml-bpa1.png": ""}alt="XML"className="xml-icon"/></button>
                                    </div>
                                    <div className="col-1 mb-3" style={{display:selectedXML=== "BP21"?"none":"block"}}>
                                        <button className="btn excel-btn mx-auto d-block" disabled={selectedXML==="BPA1"}onClick={handleExportExcel}><img src="/img/excel-export.png"alt="Excel"className="excel-icon"/></button>
                                    </div>
                                    <div className="col-10 mb-3">
                                        <select className="form-select text-center form mt-4"value={selectedXML}onChange={handleSelectXML}>
                                            <option value="BPMP">BPMP (MM Payroll)</option>
                                            {/* <option value="BP21">BP21 (Masa)</option> */}
                                            <option value="BPA1">BPA1 (A1)</option>
                                        </select>
                                    </div>
                                    {xmlPreview && (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="card">
                                                    <div className="card-header pb-0">
                                                        <p className="mb-2 mt-1 fw-bold">{selectedXML} XML Preview</p>
                                                    </div>
                                                    <div className="card-body"style={{height:"60vh",overflow: "auto",color:"rgb(108, 108, 108)",fontSize: "15px"}}>
                                                        <pre style={{ whiteSpace: "pre-wrap" }}>
                                                            {xmlPreview}
                                                        </pre>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MenuLaporanSpt